import React from 'react';
import {Project} from "../../types/Project";

type Props = {
    project: Project,
    onProjectClick: () => void
}

const ProjectsListItem: React.FC<Props> = ({project, onProjectClick}) => {
    let itemClasses = 'project-item projects-list-item'
    if (project.newLoad) {
        itemClasses += ' hidden'
        project.newLoad = false
    }

    return (
        <div className={itemClasses}>
            <a href={project.url} onClick={onProjectClick}>
                <div className={'project-customer'}>
                    {project.customer}
                </div>

                <div className={'project-title'}>
                    <div className={'title-description'}>
                        <h3>{project.title}</h3>
                        <p dangerouslySetInnerHTML={{ __html: project.description || '' }}></p>
                    </div>
                    <div className={'project-tags'}>
                        {project.tags.map((tag, index) => (
                            <span key={index}>#{tag.title}</span>
                        ))}
                    </div>
                </div>

                <div className={'project-arrow'}>
                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M45.0602 33.0599L25.0602 53.0599C24.7758 53.3249 24.3997 53.4692 24.0111 53.4623C23.6225 53.4554 23.2518 53.298 22.9769 53.0232C22.7021 52.7484 22.5447 52.3776 22.5378 51.989C22.531 51.6004 22.6752 51.2243 22.9402 50.9399L41.8777 31.9999L22.9402 13.0599C22.6752 12.7756 22.531 12.3995 22.5378 12.0109C22.5447 11.6223 22.7021 11.2515 22.9769 10.9767C23.2518 10.7019 23.6225 10.5444 24.0111 10.5376C24.3997 10.5307 24.7758 10.675 25.0602 10.9399L45.0602 30.9399C45.3411 31.2212 45.4989 31.6024 45.4989 31.9999C45.4989 32.3974 45.3411 32.7787 45.0602 33.0599Z"/>
                    </svg>
                </div>
            </a>
        </div>
    )
}

export default ProjectsListItem
